import { useCallback } from 'react';
import styled, { css } from 'styled-components';
import {
  AppAudioPlayerControlsSkip15SecForward,
  AppAudioPlayerControlsSkipForwardFilled,
  AppRadioPlayerControlsNext
} from '@elfsight/icons';
import { getColorWithAlpha } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import type { PropsWithClassName } from '../../../../../types';
import { useTheme } from '../../../common';
import { useSource } from '../../../sources';
import { usePlayer } from '../../PlayerProvider';
import { DefaultButton } from './DefaultButton';
import { Icon } from './Icon';

export function Next({ className }: PropsWithClassName) {
  const { textColor } = useTheme();
  const { sourceType } = useSettings();
  const {
    next,
    seekTo,
    duration,
    progress: { played = 0 },
    loopPlaylist
  } = usePlayer();
  const { currentItemId, items } = useSource();

  const onClick = useCallback(() => {
    if (sourceType === 'rss') {
      seekTo((duration * played + 15) / duration);
    } else {
      next();
    }
  }, [duration, next, played, seekTo, sourceType]);

  const noNextTrack =
    sourceType !== 'rss' && currentItemId === items.length - 1;
  const disabled = (!items || noNextTrack) && !loopPlaylist;

  const IconComponent = (() => {
    if (sourceType === 'rss') {
      return AppAudioPlayerControlsSkip15SecForward;
    }

    if (sourceType === 'radio') {
      return AppRadioPlayerControlsNext;
    }

    return AppAudioPlayerControlsSkipForwardFilled;
  })();

  return (
    <Component
      className={className}
      aria-label={!disabled ? 'Next' : undefined}
      onClick={!disabled ? onClick : undefined}
      _disable={disabled}
    >
      <Icon as={IconComponent} fill={getColorWithAlpha(textColor, 1)} />
    </Component>
  );
}

const Component = styled(DefaultButton)<{
  _disable: boolean;
}>`
  margin-left: 16px;
  opacity: ${({ _disable }) => (_disable ? 0.3 : 1)};
  ${({ _disable }) =>
    _disable &&
    css`
      pointer-events: none;
    `};
`;
